// extracted by mini-css-extract-plugin
module.exports = {"sectionHeader":"GroupMembers_sectionHeader__dB1YJ"};